// extracted by mini-css-extract-plugin
module.exports = {"tpbLogo":"WellsFargoAdvisorsLogo__tpbLogo___2vMNK","desktop":"WellsFargoAdvisorsLogo__desktop___195gP","mobile":"WellsFargoAdvisorsLogo__mobile___LHxmf"};